import isURI from "components/Utils/URI";
import {
  LogicalOperatorEnumerator,
  LogicalOperatorTypes,
} from "../Elements/FilterSelect/LogicalOperatorsOptions";

/**
 * Return the druid filter for Equal condition applied to Strings
 */
const setEquals = (filter, logicalOperator) => ({
  type: LogicalOperatorTypes.in,
  dimension: filter.dimension,
  values: filter.values.map((value) =>
    // in the case the value is an URI... pass the real value.. if not.. decode it because it may contain wrong values which cannot be parsed properly on BE
    isURI(value) ||
    // or.. in the case that the value contains # (hashtag)
    decodeURIComponent(value).includes("#") ||
    value.includes("%")
      ? value
      : decodeURIComponent(value)
  ),
});

/**
 * Returns the druid filter for Contains condition applied to strings
 * @param {*} filter
 * @param {*} logicalOperator
 */
const setContains = (filter, logicalOperator) => ({
  type: LogicalOperatorTypes.regex,
  dimension: filter.dimension,
  pattern: "(?i).*" + logicalOperator.value.list.join("|") + ".*",
});

const setHasValue = (filter) => ({
  type: LogicalOperatorTypes.selector,
  value: null,
  dimension: filter.dimension,
});

// Map logical operator X filter generator method
const loMapFuncSet = {
  [LogicalOperatorEnumerator.Equals]: setEquals,
  // the function is the same than Equals, however, an objection is set in the operator (not in your function)
  [LogicalOperatorEnumerator.DoesNotEqual]: setEquals,
  [LogicalOperatorEnumerator.Contains]: setContains,
  [LogicalOperatorEnumerator.DoesNotContain]: setContains,
  [LogicalOperatorEnumerator.HasValue]: setHasValue,
  [LogicalOperatorEnumerator.DoesNotHaveValue]: setHasValue,
};

/**
 * Return the right method to calculate the filter according the logical operator
 * @param {*} filterProps
 * @param {*} logicalOperator
 */
const QueryFilterStrings = (filterProps, logicalOperator) => {
  // call the calculation method according the logical operator and return the right filter
  return loMapFuncSet[logicalOperator.description](
    filterProps,
    logicalOperator
  );
};

export default QueryFilterStrings;
